import { inject, Pipe, PipeTransform } from '@angular/core';

import { ColorUtils } from '@ppg/shared/color/services';

@Pipe({
  name: 'formatRgb',
  standalone: true,
})
export class FormatRgbPipe implements PipeTransform {
  readonly #colorUtils = inject(ColorUtils);

  transform(value: string | undefined): string {
    const rgb = this.#colorUtils.stringToRgb(value);

    if (!rgb) {
      return '';
    }

    return `R: ${rgb!.r} G: ${rgb!.g} B: ${rgb!.b}`;
  }
}
